export default __webpack_public_path__ + "static/media/payment-mastercard.0ceb872c.svg";